import axios from "axios";
import httpUrl from "./httpUrl";
import router from "../../router";
import { getLinktoAuthUrl, getUrlSpecifiedParam } from "./util";
import { noRegisterPages } from "@/config/auth";
import { getRegisterQuery, linktoAuth, param } from "./util";
const API_PATH = window.API_PATH;
const appPath = window.appPath;

// 请求路径
export const HTTP_URL = httpUrl;
// 请求方法
export function httpAxios({
  url,
  method = "get",
  params = {},
  prefix = API_PATH,
}) {
  url = prefix + url;
  if (method === "get") {
    return new Promise((resolve, reject) => {
      axios[method](url, {
        params,
      })
        .then((res) => {
          // console.log(res);
          resolve(res.data);
        })
        .catch((res) => {
          console.log(url, res);
        });
    });
  } else {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
        method,
        url,
        data: params,
        transformRequest: [
          function (data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          console.log(url, res);
        });
    });
  }
}
if (sessionStorage.getItem("channel")) {
  // 渠道分析
  axios.defaults.headers["Channel-Code"] = sessionStorage.getItem("channel");
}
// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      // Object.assign(response.data,{code:510})
      switch (response.data.code) {
        // 未授权
        case 511:
          return Promise.resolve(response);
        // 授权未注册跳转注册页 除了不需要跳转注册的页面
        case 510:
          let curRoute = router.history.current;
          if (noRegisterPages.indexOf(curRoute.name) > -1) {
            return Promise.resolve(response);
          } else {
            curRoute.name !== "register" && router.push("/register");
            return Promise.resolve(response);
          }
        default:
          return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// get 请求
function httpGet({ url, params = {} }) {
  let headers = {
    "Content-type": "application/x-www-form-urlencoded",
  };
  if (sessionStorage.getItem("channel")) {
    headers["Channel-Code"] = sessionStorage.getItem("channel");
  }
  return axios
    .get(url, {
      params,
      headers: headers,
    })
    .then((res) => {
      return res.data;
    });
}
// post请求
export function httpPost({ url, data = {}, params = {} }) {
  return new Promise((resolve, reject) => {
    let axiosParams = {
      url,
      method: "post",
      transformRequest: [
        function (data) {
          let ret = "";
          for (let it in data) {
            ret +=
              encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        },
      ],
      // 发送的数据
      data,
      // url参数
      params,
    };
    if (sessionStorage.getItem("channel")) {
      axiosParams.headers = {
        "Channel-Code": sessionStorage.getItem("channel"),
      };
    }
    axios(axiosParams)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function http({
  url,
  method = "get",
  params = {},
  urlParams = {},
  before = function (request) {},
  prefix = API_PATH,
  isRegister = true,
}) {
  url = prefix + url;
  if (method === "get") {
    return httpGet({
      url,
      params,
    });
  } else if (method === "post") {
    return httpPost({
      url,
      data: params, // 兼容以前vue.$post写法，互换data/params
      params: urlParams,
    });
  }
}

export function uploadImg({ url, file }) {
  let data = new FormData();
  data.append("img", file);
  return axios({
    method: "post",
    url: API_PATH + url,
    data,
  })
    .then((res) => {
      return res.data;
    })
    .catch((res) => {
      console.log(res);
    });
}

// 授权，传入授权后需要到达页面的路由信息
export function authNeed(to, next) {
  // let route = router.history.current;
  // console.log('to', to)
  http({
    url: HTTP_URL.authNeed,
  }).then((res) => {
    // const origin = getLinktoAuthUrl(to)
    const redirectUrl = encodeURIComponent(window.location.href);
    if ([510, 513].includes(res.code)) {
      if (window.location.host.includes("test.")) {
        const pathname = window.location.pathname.split("/wechat")[0];
        window.location.href = `//${window.location.host}${pathname}/api/authservice/login?redirect=${redirectUrl}`;
      } else {
        window.location.href = `//${window.location.host}/api/authservice/login?redirect=${redirectUrl}`;
      }
    } else if (res.code === 511) {
      linktoAuth(to);
      // const pathname = location.pathname.split('/health')[0]
      // redirectUrl += '&set_ticket=1'
      // const jumpUrl = ENV === 'test' ? `${location.origin}${pathname}/api/frontend/cas/service/auth?redirect=` + encodeURIComponent(redirectUrl) : 'https://apps.dsjkyy.com/daishu_component/public/api/frontend/cas/service/auth?redirect=' + encodeURIComponent(redirectUrl)
      // jumpLink({ url: jumpUrl, replace: true })
      // setTimeout(() => {
      // }, 3000)
    } else {
      next && next();
    }
    // if (res.code === 200) {
    // } else if (res.code === 400) {
    //   next && next();
    // } else if (res.code === 201) {
    //   if (noRegisterPages.indexOf(to.name) > -1) {
    //     next ? next() : router.push(to.path);
    //     return;
    //   }
    //  不需要授权直接跳注册
    //   let query = getRegisterQuery(to);
    //   next
    //     ?
    //     next({
    //       name: "register",
    //       query
    //     }) :
    //     router.push({
    //       name: "register",
    //       query
    //     });
    // }
  });
}
export function getPoints(params) {
  return http({
    url: HTTP_URL.pointList,
    params,
  });
}
export function locate_by_lon_lat(vm, lon_lat) {
  let url =
    "https://api.daishujiankang.com/miniapp/common/locate_by_lon_lat?lon_lat=" +
    lon_lat;
  return new Promise((resolve, reject) => {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve({
          city_id: 200,
          name: "深圳",
        });
      })
      .catch((res) => {
        resolve({
          city_id: 200,
          name: "深圳",
        });
        console.log("warn");
      });
  });
}

// 提交发票
export function submitInvoice(vm, params) {
  return http({
    url: "order/add_invoce",
    method: "post",
    params,
  });
}
export function submitCardInvoice(params) {
  return http({
    url: "familydoctor/add_invoice",
    method: "post",
    params,
  });
}
export function getSelfCredit(params) {
  return http({
    url: "coupon/self_credit",
    params,
  });
}
// 获取订单列表
export function getOrderListV2(vm, params) {
  return http({
    url: "user/order_list_v2",
    params,
  });
}

// 获取追踪订单列表
export function orderTrackList(vm, params) {
  return http({
    url: "user/orderTrackList",
    params,
  });
}

// 获取服务器时间
export function getServerTime(vm) {
  return http({
    url: "api/get_system_time",
    prefix: appPath,
  });
}

// 获取热门套餐列表
export function getHotPackage(params) {
  return http({
    url: "api/get_hot_package",
    params: params,
    prefix: appPath,
  });
}

// 获取城市id
export function getCityId(vm, cityName) {
  vm.global.is_first_get_id = false;
  return http({
    url: "api/get_cityId_by_name",
    prefix: appPath,
    params: {
      company_id: 0,
      city_name: cityName,
    },
  });
}

// 机构列表
export function getOrgList(params) {
  return http({
    url: "org/list",
    params,
  });
}

export function getCityList(vm) {
  let url = appPath + "city/qqindex?company_id=0&jsondata=1";
  return http({
    url: "city/qqindex",
    params: {
      company_id: 0,
      jsondata: 1,
    },
  });
}

// 获取常用体检人列表
export function getFamily(vm) {
  return http({
    url: "user/familes",
  });
}

// 优惠券
export function getCoupons(vm) {
  return http({
    url: HTTP_URL.getCoupons,
    prefix: appPath,
  });
}

// 新优惠券列表页
export function getCouponsAll(vm, params) {
  return http({
    url: HTTP_URL.getCouponsAll,
    prefix: appPath,
    params,
  });
}

// 订单页优惠券
export function getAbleCoupon(vm, params) {
  return http({
    url: HTTP_URL.getAbleCoupon,
    params,
  });
}

// 套餐详情
export function getPackageDetailV2(vm, params) {
  return http({
    url: "package/PackageDetail",
    params,
  });
}

// 套餐标签
export function getTags(vm, params) {
  return http({
    url: "api/get_tags",
    params,
    prefix: appPath,
  });
}

// 套餐细项
export function getPackageItemsByIds(vm, params) {
  return http({
    url: "api/get_package_items_by_ids",
    params,
    prefix: appPath,
  });
}

// 意见反馈
export function feedback(vm, params) {
  let url = API_PATH + "user/feedback";
  return http({
    url: "user/feedback",
    method: "post",
    params,
  });
}
export function orderDelete(vm, params, isCardOrder) {
  let url = isCardOrder
    ? API_PATH + "medicalcard/order"
    : API_PATH + "order/delete_order";
  if (isCardOrder) {
    return new Promise(function (resolve, reject) {
      vm.$http
        .delete(url, {
          body: params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          console.log("warn");
        });
    });
  } else {
    return http({
      url: "order/delete_order",
      method: "post",
      params,
    });
  }
}

// 取消订单
export function orderCancel(vm, params, isCardOrder) {
  let url = isCardOrder
    ? API_PATH + "medicalcard/order"
    : API_PATH + "order/cancel";
  return new Promise(function (resolve, reject) {
    vm.$http
      .patch(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log("warn");
      });
  });
}

// 确认收到报告
export function confirmReportRequest(vm, params) {
  let url = API_PATH + "order/receive";
  return http({
    url: "order/receive",
    method: "post",
    params,
  });
}

// 订单详情
export function getOrderDetail(vm, params) {
  return http({
    url: "order/detail",
    params,
  });
}

// 订单详情V2
export function getOrderDetailV2(vm, params) {
  return http({
    url: "order/detail_v2",
    params,
  });
}
// 订单详情V2
export function orderBookingDate(vm, params) {
  return http({
    url: "order/orderBookingDate",
    method: "post",
    params,
  });
}
// 排期
export function getSchedule(vm, params) {
  // let url = API_PATH + 'org/schedule?' + param(params);
  return http({
    url: "org/schedule",
    params,
  });
}

// 改期
export function changeDate(vm, params) {
  let url = API_PATH + "order/reserve";
  return new Promise(function (resolve, reject) {
    vm.$http
      .patch(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log("warn");
      });
  });
}

// 获取用户信息
export function getUserInfoV1(vm) {
  let url = API_PATH + "user/user_info_v2";
  return new Promise((resolve, reject) => {
    http({
      url: "user/user_info_v2",
    })
      .then((res) => {
        res.code === 511 ? authNeed(vm.$route) : resolve(res);
      })
      .catch((res) => {
        console.log("获取用户信息失败");
        vm.$router.push("/register");
      });
  });
}

// 获取用户信息（未注册时自动跳转到注册页面）
export function getUserInfoV2(vm) {
  let url = API_PATH + "user/user_info_v2";
  return new Promise((resolve, reject) => {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        res = res.data;
        if (
          res.code === 510 &&
          window.location.href.indexOf("register") === -1
        ) {
          const origin = encodeURIComponent(window.location.href);
          if (window.location.host.includes("test.")) {
            const pathname = window.location.pathname.split("/wechat")[0];
            window.location.href = `//${window.location.host}${pathname}/api/authservice/login?redirect=${origin}`;
          } else {
            window.location.href = `//${window.location.host}/api/authservice/login?redirect=${origin}`;
          }
          // 授权未注册
          // vm.$router.push("/register");
          return;
        } else if (res.code === 511) {
          // linktoAuth(to)
          const origin = encodeURIComponent(window.location.href);
          document.cookie = `return_url=${origin};path=/`;
          location.replace(`${appPath}wechat/auth_entrance`);
        }
        // 未授权
        // if (res.code === 511) {
        //   authNeed(vm.$route);
        //   return;
        // }
        // if (res.code == 511) { //未授权
        //   let beforeUrl = window.location.href.split("#/")[0] + '#/';
        //   let url = encodeURIComponent(beforeUrl);
        //   document.cookie = "return_url=" + url + ";path=/";
        //   window.location.href = appsRootPath + "wechat/wechat/auth_entrance";
        // }
        resolve(res);
      })
      .catch((res) => {
        console.log("获取用户信息失败");
        vm.$router.push("/register");
      });
  });
}

/* 变啦 bianla */
// 套餐列表
export function bianlaList(vm, params) {
  return http({
    url: "package/bianla_list",
    params,
  });
}

// 套餐详情
export function bianlaDetail(vm, params) {
  return http({
    url: "package/detail",
    params,
  });
}

// 优惠券
export function bianlaHandle(vm, params) {
  return http({
    url: "activity/handle",
    params,
  });
}

// 体检卡列表
export function getCardList(vm, params) {
  return http({
    url: "medicalcard/list",
    params,
  });
}

// 体检卡详情
export function getCardDetailV1(vm, params) {
  return http({
    url: HTTP_URL.getCardDetail,
    params,
  });
}

// 体检卡详情
export function getCardDetailV2(vm, params) {
  return http({
    url: "medicalcard/cardDetails",
    params,
  });
}

// 机构详情
export function getOrgDetail(vm, params) {
  return http({
    url: "org/new_org_detail",
    params,
  });
}

// 体检卡订单详情
export function getCardOrder(vm, params) {
  return http({
    url: "medicalcard/order_info",
    params,
  });
}

// 体检卡支持城市
export function getCardCityList(vm, params) {
  return http({
    url: "medicalcard/support_cities",
    params,
  });
}

// 催单
export function reminder(vm, params) {
  return http({
    url: HTTP_URL.feedback,
    method: "post",
    params: {
      content: `系统消息：该用户点击了订单ID：${params.id}体检报告催单按钮，请尽快处理`,
      reminder: 1,
      order_id: params.id,
    },
  });
}

// 卡密兑换机构列表
export function getCardPackageList(vm, params) {
  console.log(params);
  return http({
    url: "medicalcard/package_list",
    params,
  });
}

// 体检卡套餐tag
export function getCardTags(vm, params) {
  // let url = API_PATH + 'package/tags?' + param(params)
  return http({
    url: httpUrl.getCardTags,
    params,
  });
}

// 体检卡订单列表
export function getCardOrderList(vm, params) {
  return http({
    url: "medicalcard/orders",
  });
}

// 体检卡兑换接口
export function submitCardPsd(vm, params) {
  return http({
    url: httpUrl.medicalcardExchange,
    params,
  });
  // let url = API_PATH + 'medicalcard/exchangeNew?' + param(params)
  // return new Promise((resolve, reject) => {
  //   vm.$http
  //     .get(url, {
  //       emulateJSON: true
  //     })
  //     .then(res => {
  //       resolve(res.data)
  //     })
  //     .catch(res => {
  //       console.log('warn')
  //     })
  // })
}

// 提交订单
export function submitOrderForm(vm, params) {
  let url = API_PATH + "order/reserve";
  return new Promise((resolve, reject) => {
    vm.$http
      .post(url, params, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log("warn");
      });
  });
}

// 体检卡发票
export function saveCardInvoice(vm, params) {
  let url = API_PATH + "medicalcard/invoice";
  return new Promise(function (resolve, reject) {
    vm.$http
      .post(url, params, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log("保存发票失败");
      });
  });
}

// 获取验证码
export function getPhoneCode(vm, params) {
  let url = API_PATH + "user/rand_code?" + param(params);
  return new Promise((resolve, reject) => {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log("warn");
      });
  });
}

// 申请退款
export function orderRefund(vm, params) {
  let url = API_PATH + "order/refund";
  return new Promise(function (resolve, reject) {
    vm.$http
      .post(url, params, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log("退款失败");
      });
  });
}

// 传入套餐id来判定该套餐是否含有加项数据
export function isAddition(vm, params) {
  let url = `${API_PATH}package/package_has_extra?${param(params)}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  });
}
export function hasBaseExtraPackage(params) {
  return http({
    url: "package/has_base_extra_package",
    params,
  });
}
// 获取加项数据
export function getAdditionData(vm, params) {
  let url = `${API_PATH}package/base_extra_package?${param(params)}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  });
}
export function getCardAddition(vm, params) {
  let url = `${API_PATH}AgentCard/base_extra_package?${param(params)}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  });
}

// 变啦体检卡超时处理
export function medicalcardOvertimeHandle(vm, params) {
  let url = `${API_PATH}medicalcarduser/change_status?id=${params.id}&status=4`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  });
}

// 获取首页banner
export function getIndexBanner(vm, params) {
  let url = `${appPath}page_config/indexBanner?city_id=${params.cityId}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  });
}

// 获取个人中心页banner
export function getUserCenterBanner(vm, params) {
  let url = `${appPath}page_config/userCenterBanner?city_id=${params.cityId}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  });
}

// 获取D米数据
export function getDMiData(vm, params) {
  let url = `${appPath}usercenter/dmi_handle?handle=read_my_dmi`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        console.log(res);
      });
  });
}

// 增加收藏(collect_id:收藏的机构或套餐id, type:收藏的类型，1机构，2套餐)
export function addCollection(vm, params) {
  let url = `collect/add`;
  return new Promise(function (resolve, reject) {
    http({
      url,
      method: "post",
      params,
    })
      .then((res) => {
        // 点击收藏时，如果用户未授权，则先把该数据存到本地缓存，授权完毕再执行收藏方法
        if (res.code === 511) {
          params.timeStamp = new Date().getTime();
          sessionStorage.setItem("collectionFlag", JSON.stringify(params));
          authNeed(vm.$route);
        } else {
          resolve(res);
        }
      })
      .catch((res) => {
        reject(res);
        console.log("warn");
      });
  });
}

// 取消收藏(collect_id: 取消收藏的机构或套餐id，多个用逗号分隔)
export function cancelCollection(vm, params) {
  let url = `${API_PATH}collect/cancel?${param(params)}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .patch(url, {
        emulateJSON: true,
      })
      .then((res) => {
        res.body.code === 511 ? authNeed(vm.$route) : resolve(res.data);
      })
      .catch((res) => {
        reject(res);
        // console.log('warn')
      });
  });
}

// 删除历史记录
export function delHistoryPackage(vm, params) {
  let url = `${API_PATH}${HTTP_URL.remPackageBrowse}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .post(url, params, {
        emulateJSON: true,
      })
      .then((res) => {
        res.body.code === 511 ? authNeed(vm.$route) : resolve(res.data);
      })
      .catch((res) => {
        reject(res);
        console.log("warn");
      });
  });
}

// 添加对比列表
export function addPackageCompare(vm, params) {
  let url = `${API_PATH}package/addPackageCompare`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .post(url, params, {
        emulateJSON: true,
      })
      .then((res) => {
        // 点击pk，如果用户未授权，则先把该数据存到本地缓存，授权完毕再执行pk方法
        if (res.body.code === 511) {
          params.timeStamp = new Date().getTime();
          sessionStorage.setItem("compareFlag", JSON.stringify(params));
          authNeed(vm.$route);
        } else {
          resolve(res.data);
        }
      })
      .catch((res) => {
        reject();
        console.log("warn");
      });
  });
}

// 从对比列表中删除指定套餐(ids: 取消收藏的机构或套餐id，多个用逗号分隔)
export function remPackageCompare(vm, params) {
  let url = `${API_PATH}package/remPackageCompare`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .post(url, params, {
        emulateJSON: true,
      })
      .then((res) => {
        res.body.code === 511 ? authNeed(vm.$route) : resolve(res.data);
      })
      .catch((res) => {
        reject();
        console.log("warn");
      });
  });
}

// 获取收藏列表(type: 1机构，2套餐)
export function getCollectionList(vm, params) {
  let url = `collect/list?${param(params)}`;
  return new Promise(function (resolve, reject) {
    http({
      url,
    })
      .then((res) => {
        res.code === 511 ? authNeed(vm.$route) : resolve(res);
      })
      .catch((res) => {
        reject();
        console.log("warn");
      });
  });
}

// 获取浏览历史列表
export function getPackageBrowseList(vm, params) {
  return new Promise(function (resolve, reject) {
    let url = `${API_PATH}${HTTP_URL.packageBrowseList}`;
    http({
      url: HTTP_URL.packageBrowseList,
      params,
    })
      .then((res) => {
        res.code === 511 ? authNeed(vm.$route) : resolve(res);
      })
      .catch((res) => {
        reject();
        console.log("warn");
      });
  });
}

// 获取支持机构列表
export function getSupportOrgList(vm, params) {
  let url = `${API_PATH}medicalcard/packageList?${param(params)}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        reject();
        console.log("warn");
      });
  });
}

// 获取推荐体检卡
export function getRecommendMedicalCard(vm, params) {
  let url = `${API_PATH}medicalcard/recommend?${param(params)}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        reject();
        console.log("warn");
      });
  });
}

// 体检卡赠送数据
export function medicalCardGiftDetail(vm, params) {
  let url = `${API_PATH}Medicalcarduser/giftDetail?${param(params)}`;
  return new Promise(function (resolve, reject) {
    vm.$http
      .get(url, {
        emulateJSON: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((res) => {
        reject();
        console.log("warn");
      });
  });
}

// 获取企业合作相关数据
export function getRequirement(vm, params) {
  return http({
    url: HTTP_URL.requirement,
    params,
  });
}

// 提交企业合作表单数据
export function postRequirement(vm, params) {
  return http({
    url: HTTP_URL.requirement,
    method: "post",
    params,
  });
}

// 提交企业合作表单数据
export function getUserCenterMeassage(vm) {
  return http({
    url: HTTP_URL.userCenterMeassage,
    method: "get",
  });
}

// 提交企业合作表单数据
export function isSeeMessage(vm, params) {
  return http({
    url: HTTP_URL.isSeeMessage,
    method: "get",
    params,
  });
}
export function getCustomerQList(type) {
  let params = type
    ? {
        type,
      }
    : null;
  return http({
    url: HTTP_URL.customerQList,
    params,
  });
}
export function getCustomerAns(title_id) {
  return http({
    url: HTTP_URL.customerAns,
    params: {
      title_id,
    },
  });
}
export function getCustomerRate(params) {
  return http({
    url: HTTP_URL.customerRate,
    method: "post",
    params,
  });
}

export function getDmiRecord(params) {
  return http({
    prefix: API_PATH,
    // prefix: appPath,
    url: HTTP_URL.dmiRecord,
    params,
  });
}
export function getDmiList() {
  return http({
    prefix: appPath,
    url: HTTP_URL.dmiList,
  });
}
export function getDmiInfo(params) {
  return http({
    prefix: API_PATH,
    // prefix: appPath,
    url: HTTP_URL.dmiInfo,
    params,
  });
}
export function activityHandle(params) {
  return http({
    // prefix: appPath,
    url: HTTP_URL.activityHandle,
    params,
  });
}
export function activityRandCode(params) {
  return http({
    prefix: appPath,
    url: HTTP_URL.activityRandCode,
    params,
  });
}

export function getUserInfo() {
  return http({
    url: HTTP_URL.userInfoV2,
  });
}
export function verifyPicCode(params) {
  return http({
    url: HTTP_URL.verifyPicCode,
    params,
  });
}
export function getRandCode(params) {
  return http({
    url: HTTP_URL.getRandCode,
    params,
    prefix: appPath,
  });
}

export function userRegister(params) {
  return http({
    url: HTTP_URL.userRegister,
    params,
    method: "post",
  });
}
export function getMyCoupons(params) {
  return http({
    url: HTTP_URL.myCoupons,
    params,
  });
}

export function isPartnerCodeValid(params) {
  return http({
    url: HTTP_URL.isPartnerCodeValid,
    params,
  });
}
export function getOfferDetails(params) {
  return http({
    url: HTTP_URL.offerDetails,
    params,
  });
}
export function getActivityList(params) {
  return http({
    url: HTTP_URL.getPackageList,
    prefix: appPath,
    params,
  });
}

export function check_user_order() {
  return http({
    url: HTTP_URL.check_user_order,
    prefix: appPath,
  });
}

export function loginInfo() {
  return http({
    url: HTTP_URL.loginInfo,
    // params
  });
}

export function getCardList2() {
  return http({
    url: HTTP_URL.cardList2,
  });
}

export function getCouponsAll2(vm) {
  return http({
    url: HTTP_URL.getCouponsAll,
    params: {
      type: 1,
    },
    prefix: appPath,
  });
}

export function doctorLayout() {
  return http({
    url: HTTP_URL.doctorLayout,
  });
}

// 拼团
export function getGropBuyList(params) {
  return http({
    url: HTTP_URL.getGropBuyList,
    params,
  });
}
export function getPackageGroupBuyInfo(params) {
  return http({
    url: HTTP_URL.getPackageGroupBuyInfo,
    params,
  });
}
export function getPackageListGroupBuy(params) {
  return http({
    url: HTTP_URL.getPackageListGroupBuy,
    prefix: appPath,
    params,
  });
}
export function getPackageListActivity(params) {
  return http({
    url: HTTP_URL.getPackagesListActivity,
    prefix: appPath,
    params,
    method: "post"
  });
}
export function getOrgListGroupBuy(params) {
  return http({
    url: HTTP_URL.getOrgListGroupBuy,
    prefix: appPath,
    params,
  });
}
export function getGroupBuyTopList(params) {
  return http({
    url: HTTP_URL.getGroupBuyTopList,
    prefix: appPath,
    params,
  });
}

export function familydoctorCanCelOrder(params) {
  return http({
    url: HTTP_URL.familydoctorCanCelOrder,
    method: "post",
    params,
  });
}

export function familydoctorConfirmReceipt(params) {
  return http({
    url: HTTP_URL.familydoctorConfirmReceipt,
    method: "post",
    params,
  });
}

export function familydoctorSelTrack(params) {
  return http({
    url: HTTP_URL.familydoctorSelTrack,
    method: "get",
    params,
  });
}

export function festivalHotsearch() {
  return http({
    url: HTTP_URL.festivalHotsearch,
    method: "get",
  });
}

export function festivalBanner(params) {
  return http({
    url: HTTP_URL.festivalBanner,
    methods: "get",
    params,
  });
}

export function addReport(data) {
  return axios({
    url: API_PATH + HTTP_URL.addReport,
    method: "post",
    // params,
    data,
  });
}

export function getRecommendHospital(params) {
  return http({
    url: HTTP_URL.getRecommendHospital,
    method: "get",
    params,
  });
}
export function get58PackagesList(params) {
  return http({
    url: HTTP_URL.get58PackagesList,
    method: "get",
    params,
  });
}

export function getWellChosenPackage(params) {
  return http({
    url: HTTP_URL.getWellChosenPackage,
    method: "get",
    params,
  });
}

// 【SEO优化】广告渠道全链路数据追踪
export function seoVisitLog() {
  if (getUrlSpecifiedParam("hmsr")) {
    // 链路跟踪
    return http({
      url: `${HTTP_URL.seoVisitLog}?${window.location.href.split("?")[1]}`,
      method: "get",
    });
  }
}

export function getPocketEntryExamPackage(params) {
  return http({
    url: HTTP_URL.pocketEntryExamPackage,
    method: "get",
    params,
  });
}

// export function uploadImg(params) {
//   uploadImg
//   return http({
//     url: HTTP_URL.uploadImg,
//     method: 'post',
//     params
//   })
// }

export function getMallCardList() {
  return http({
    url: HTTP_URL.getMallCardList,
  })
}

export function getMallCardDetail(params) {
  return http({
    url: HTTP_URL.getMallCardDetail,
    params
  });
}


export function getPrepaidCardList(params) {
  return http({
    url: HTTP_URL.getPrepaidCardList,
    params: { type: 5 }  // type 5 为预付卡
  });
}

export function createCardOrder(params, vm = {}) {
  // return http({
  //   url: HTTP_URL.createCardOrder,
  //   method: 'post',
  //   params
  // });
  return new Promise((resolve, reject) => {
    http({
      url: HTTP_URL.createCardOrder,
      method: 'post',
      params
    })
      .then((res) => {
        res.code === 403 ? authNeed(vm.$route) : resolve(res);
      })
      .catch((res) => {
      });
  });
}

export function activePrepaidCard(params) {
  return http({
    url: HTTP_URL.activePrepaidCard,
    method: 'post',
    params
  });
}

export function getCardDealDetail(params) {
  return http({
    url: HTTP_URL.getCardDealDetail,
    params
  });
}


